var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group-item",class:_vm.active ? 'active' : ''},[_c('div',{staticClass:"group-avatar"},[_c('head-image',{attrs:{"size":42,"name":_vm.group.showGroupName,"url":_vm.group.headImageThumb}})],1),_c('div',{staticClass:"group-name"},[_c('div',[_vm._v(_vm._s(_vm.group.showGroupName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }